module.exports = __webpack_public_path__ + "static/media/bacardi.9977da84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/bacardi/bacardi.png
// module id = 755
// module chunks = 0